import Axios from "axios";
import {
  SET_PROFORMA_INVOICE_LIST,
  UNSET_PROFORMA_INVOICE_LIST,
} from "@/store/mutation-types";

import { proformaInvoiceResource } from "@/store/api";

const state = {
  getProformaInvoiceList: [],
};

const getters = {
  getProformaInvoiceList(state) {
    return state.getProformaInvoiceList;
  },
};

const mutations = {
  [SET_PROFORMA_INVOICE_LIST](state, data) {
    state.getProformaInvoiceList = data;
  },
  [UNSET_PROFORMA_INVOICE_LIST](state) {
    state.getProformaInvoiceList = [];
  },
};

const actions = {

    getProformaInvoiceList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(proformaInvoiceResource, { params })
            .then((response) => {
            commit(SET_PROFORMA_INVOICE_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_PROFORMA_INVOICE_LIST);
            reject(error);
            });
        });
    },

    saveProformaInvoice({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(proformaInvoiceResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateProformaInvoice({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${proformaInvoiceResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getProformaInvoiceById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${proformaInvoiceResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

